import { connect } from 'react-redux';
import { IAppState } from '../../../common/state';
import { ButtonPrintExcelGroup } from './bottom_print_excel';

export const ButtonPrintExcelGroupContainer = connect(({ results }: IAppState) => ({
  queryString: results.queryString,
}))(ButtonPrintExcelGroup);
